import { Button, Result } from 'antd'
import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const availableRoutes: string[] = ['/articles', '/events', '/stories', '/how', '/about']

type TPageNotFoundProps = {
	message?: string
}

function PageNotFound({}: TPageNotFoundProps) {
	const location = useLocation()
	const history = useHistory()

	const backToHomeAction = useCallback(() => history.push('/'), [history])

	if (availableRoutes.includes(location.pathname)) {
		return (
			<Result
				title="Sorry, this page in progress!"
				subTitle="We are already finishing testing this page and will release it soon!"
				extra={
					<Button shape="round" type="primary" onClick={backToHomeAction}>
						Back Home
					</Button>
				}
			/>
		)
	}

	return (
		<Result
			status="404"
			title="404"
			subTitle="We’re sorry, this expert is unavailable but we have more to choose from."
			extra={
				<Button shape="round" type="primary" onClick={backToHomeAction}>
					See All Experts
				</Button>
			}
		/>
	)
}

export default PageNotFound
